/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PurposeOfVisitEnum {
  BUSINESS = 'business',
  IMMIGRATION = 'immigration',
  STUDIES = 'studies',
  TOURIST = 'tourist',
  WORK = 'work'
}

